'use client';

import {
	ExclamationTriangleIcon,
	InformationCircleIcon,
} from '@heroicons/react/24/outline';
import clsx from 'clsx';
import { useState } from 'react';

import { useAuth } from '@/entities/user';
import { Button } from '@/shared';

import { partitionVisibleNotifications } from '../model/advertisement';
import { useSystemAlerts } from '../use-system-alerts';
import { SystemAlertModal } from './system-alert-modal';

export const SystemAlertButton = ({ onOpen }: { onOpen?: () => void }) => {
	const { alerts: allAlerts } = useSystemAlerts();
	const { user } = useAuth();
	const { alerts } = partitionVisibleNotifications(
		allAlerts,
		user?.contentPermissionLevel,
	);
	const [isOpen, setIsOpen] = useState(false);

	if (alerts.length === 0) {
		return null;
	}

	// Определяем цвет на основе первого алерта
	const firstAlertLevel = alerts[0].level;
	const isError = firstAlertLevel === 'error';
	const isInfo = firstAlertLevel === 'info';
	const isWarning = firstAlertLevel === 'warning';

	const handleOpen = () => {
		onOpen?.();
		setIsOpen(true);
	};

	const handleClose = () => {
		setIsOpen(false);
	};

	return (
		<>
			<Button
				type="button"
				variant="gray"
				size="40"
				className={clsx('w-10 !px-2', {
					'!bg-red-light !text-red hover:!bg-red-light/80': isError,
					'!bg-indigo/20 !text-indigo hover:!bg-indigo/40': isInfo,
					'!bg-yellow/20 !text-yellow hover:!bg-yellow/40': isWarning,
				})}
				onClick={handleOpen}
				aria-label="Важная информация"
			>
				{isError ? (
					<ExclamationTriangleIcon className="size-5" aria-hidden="true" />
				) : (
					<InformationCircleIcon className="size-5" aria-hidden="true" />
				)}
			</Button>

			<SystemAlertModal alerts={alerts} isOpen={isOpen} onClose={handleClose} />
		</>
	);
};
